export const recentConstants = {
    ACTIVE_FOOTER: 'ACTIVE_FOOTER',
    ACTIVE_FOOTER_CLEAR: 'ACTIVE_FOOTER_CLEAR'
};